import { SelectOption, SingleSelectFieldV2 } from '@bimone/bimtrackreactcomponents';
import { getDevApiUrlFromEnvironment, getDevEnvironmentFromUrl } from '../../../common/api/apiUrlHelpers';
import { reload, updateApiUrl, updateHub, updateProject } from '../../redux/reducers/session';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSession } from '../../modules/session';
import styled from 'styled-components';

const EnvironmentSelectorContainer = styled.div`
  margin-bottom: 2rem;
`;

interface EnvironmentSelectorProps {
  onEnvironmentChanged: () => void;
  supportedEnvironments: string[];
}

const EnvironmentSelector = ({
  onEnvironmentChanged,
  supportedEnvironments,
}: EnvironmentSelectorProps): JSX.Element => {
  const { bimTrackApiUrl } = useSession();

  const envSelectorOptions = supportedEnvironments.map(e => ({ label: e, value: e }));

  const dispatch = useDispatch();
  const selectedEnv = useMemo(() => {
    const env = getDevEnvironmentFromUrl(bimTrackApiUrl);
    return envSelectorOptions.find(o => o.value === env) || envSelectorOptions[0];
  }, [bimTrackApiUrl, envSelectorOptions]);

  const environmentSelectionChanged = (selectedEnv: SelectOption<string>): void => {
    const apiUrl = getDevApiUrlFromEnvironment(selectedEnv.value);
    onEnvironmentChanged();
    dispatch(updateApiUrl({ apiBaseUrl: apiUrl }));
    dispatch(updateHub(undefined));
    dispatch(updateProject(undefined));

    // The page is reloaded because we can't find a way to make the OIDC AuthProvider
    // to use the updated environment immediately. The new environment is saved in the session
    // so upon reload, it will be possible to log in to this environment.
    dispatch(reload());
  };

  return (
    <EnvironmentSelectorContainer>
      <SingleSelectFieldV2
        label={'Environment'}
        options={envSelectorOptions}
        onChange={environmentSelectionChanged}
        editing
        sideway
        value={selectedEnv}
        searchable={false}
      />
    </EnvironmentSelectorContainer>
  );
};

export default EnvironmentSelector;
